import { defa }     from 'defa-object';
import AlarmCentral from 'scripts/defa/alarm-centrals/model-alarm-central';

const api = {
	alarmCentrals: defa.vars.apiHost + '/insurance'
};

/**
 * defa.collections.AlarmCentrals
 * A collection of AlarmCentral models.
 * @version 1.2.0
 */

const AlarmCentrals = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	url       : api.alarmCentrals,
	model     : AlarmCentral,
	comparator: function ( model ) {
		return model.get( 'name' );
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Returns a new AlarmCentrals collection filtered by an array of ids.
	 * @param  {array}      ids  An array of ids to filter the collection by.
	 * @return {collection}      The filtered AlarmCentralCollection.
	 */
	filterByIds: function ( ids ) {
		let array = this.filter( function ( customer ) {
			return _.contains( ids, customer.get( 'id' ) );
		} );
		
		return new AlarmCentrals( array );
	},
	
	
} );

export default AlarmCentrals;